import { customAlphabet } from 'nanoid'

const nanoid = customAlphabet(
  '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
)

export const defaultLength = 21
export const getId = () => nanoid(defaultLength)
export const isValidId = (id: string) => id.length === defaultLength

export const getIdForHTML = () => {
  // html IDs must start with a letter
  return customAlphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz')(
    defaultLength
  )
}

export { getIdempotentId } from './get-idempotent-id'
